module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "western8",
    attrs: {
      "id": "calibre_pb_5"
    }
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western7"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western7"
  }, [_vm._v("We’ve grown, you and I,")]), _vm._v(" "), _c('p', {
    staticClass: "western7"
  }, [_vm._v("In different ways,")]), _vm._v(" "), _c('p', {
    staticClass: "western7"
  }, [_vm._v("On different days,")]), _vm._v(" "), _c('p', {
    staticClass: "western7"
  }, [_vm._v("Isn’t it lonely together?")]), _vm._v(" "), _c('p', {
    staticClass: "western2"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western9"
  }, [_vm._v("Deborah D. Moore")]), _vm._v(" "), _c('p', {
    staticClass: "western9"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western9"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western10"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western9"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western9"
  }, [_c('br', {
    staticClass: "calibre2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "western9"
  }, [_c('br', {
    staticClass: "calibre2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12df88d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_005.vue
// module id = 75
// module chunks = 0